<template>
  <div id="app">
    <Header />
    <transition name="pageTransition" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import Header from "./components/Header"

export default {
  name: 'App',
  components: {
    Header,
  }
}
</script>

<style lang="scss">
// add some bootstrap stuff (only what we need)
@import "./styles/bootstrap/bootstrap-reboot";
@import "./styles/bootstrap/bootstrap-grid";
@import "./styles/bootstrap/_utilities";
@import "./styles/bootstrap/_buttons";
@import "./styles/bootstrap/_forms";
@import "./styles/bootstrap/_spinners";

@import "./styles/variables";

// global styles below
body {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.btn {
  border-radius: 3px;

  &.btn-primary {
    color: white;
    background-color: $pink;
    border-color: $pink;

    &:hover {
      color: white;
      background-color: darken($pink, 10%);
      border-color: darken($pink, 10%);
    }

    &:not(:disabled):not(.disabled):active,
    &:not(:disabled):not(.disabled):focus {
      background-color: darken($pink, 10%);
      border-color: darken($pink, 10%);
      box-shadow: 0 0 0 0.2rem rgba($pink, 0.5)
    }
  }

  &.btn-outline-primary {
    color: $pink;
    background-color: white;
    border-color: $pink;

    &:hover {
      color: white;
      background-color: $pink;
      border-color: $pink;
    }

    &:not(:disabled):not(.disabled):active,
    &:not(:disabled):not(.disabled):focus {
      background-color: $pink;
      border-color: $pink;
      box-shadow: 0 0 0 0.2rem rgba($pink, 0.5);
    }
  }

  &.btn-light {
    color: $pink;
    background-color: white;
    border-color: white;

    &:hover {
      color: $pink;
      background-color: darken(white, 10%);
      border-color: darken(white, 10%);
    }
  }
}

ul.social {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0;
  margin: 0;
  list-style: none;

  li {
    margin: 0 0 13.3px;

    &:last-child {
      margin-bottom: 0;
    }

    a {
      width: 31px;
      height: 31px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      border: 1.4px solid rgba(white, 0.16);
      transition: border-color 250ms;

      &:hover {
        border-color: $pink;
      }

      img {
        max-width: 15px;
        height: auto;
      }
    }
  }
}

input.form-control {
  &:active,
  &:focus {
    box-shadow: 0 0 0 0.2rem rgba($pink, 0.15);
  }
}

// page transition, fade out and slide down
.pageTransition-enter-active, .pageTransition-leave-active {
  transition: opacity 500ms, transform 500ms;
}
.pageTransition-enter, .pageTransition-leave-to {
  opacity: 0;
  transform: translateY(100px) !important;
}
</style>
